import { serverApiConfig } from '../config';
import EventEmitter from '../utilities/service';
import { getGrpcResponse } from '../utilities/getGrpcResponse';
const { SymbolClient } = require('../grpc/generated/symbol_grpc_web_pb.js');

export default class ListArray {
  async getListArray(request, metadata) {
    return new Promise((resolve, reject) => {
      let symbolClient = new SymbolClient(
        serverApiConfig(localStorage.getItem('trade.server')),
        null,
        null
      );
      symbolClient.listArrayNew(request, metadata, (err, response) => {
        if (response === null) {
          setTimeout(() => {
            console.log('reconnect');
            window.location.reload();
          }, 5000);
          reject(err);
          return;
        }
        
        let allSymbols = [];
        getGrpcResponse(response)[0].forEach((symbolData) => {
          let symbol = {
            symbol: symbolData[84],
            full_name: symbolData[84],
            exchange: 'IUX',
            description: symbolData[84],
            type: symbolData[59].split('\\')[1],
            digit: symbolData[17],
            company_name: symbolData[16],
            logo: symbolData[103],
            currency_margin: symbolData[12],
            contract_size: symbolData[8],
            volume_max: symbolData[95],
            volume_min: symbolData[97],
            stops_level: symbolData[77] ?? 0,
            exec_mode: symbolData[19] ?? 0,
            trade_mode: symbolData[92] ?? 0,
            volume_step: symbolData[99],
            calc_mode: symbolData[2] ?? 0,
            currency_base: symbolData[10],
            currency_profit: symbolData[14],
            currency_margin_digits: symbolData[13],
            currency_profit_digits: symbolData[15],
            stats:  {
              symbol: symbolData[102][0],
              datetime: symbolData[102][1],
              bid_high: symbolData[102][2],
              bid_low: symbolData[102][3],
              ask_high: symbolData[102][4],
              ask_low: symbolData[102][5],
              datetime_msc: symbolData[102][24],
            }
          };
          allSymbols.push(symbol);
        });
        
        localStorage.setItem('symbols.trading.data', JSON.stringify(allSymbols));
        EventEmitter.dispatch('listArray', allSymbols);
        resolve(allSymbols);
      });
    });
  }
}
